import { render, staticRenderFns } from "./DrawTools.vue?vue&type=template&id=33477008&scoped=true"
import script from "./DrawTools.vue?vue&type=script&lang=js"
export * from "./DrawTools.vue?vue&type=script&lang=js"
import style0 from "./DrawTools.vue?vue&type=style&index=0&id=33477008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33477008",
  null
  
)

export default component.exports